/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import isNil from 'lodash-es/isNil';
import { useClient } from '../../../ClientProvider';
import { OrgRole } from '../../../enums';
import { CLIENT_PREFIX, FARMER_PREFIX, TECH_RPEFIX } from '../../../resources/waterBalanceArvalis.type';
import useQuery from '../../../useQuery';
import { useArvalisClientIdFromOrg } from './useArvalisClientIdFromOrg';
const getInfosFromMember = (member) => {
    let result = { city: '', zipCode: '', mail: null, firstName: null, lastName: null };
    if (!isNil(member)) {
        const [firstName, lastName] = member.name.split(' ');
        const mail = member.email;
        result = { firstName: firstName || '', lastName: lastName || '', mail, city: '', zipCode: '' };
    }
    return result;
};
const getInfosFromOrgNetwork = (orgNtwkOwner) => {
    let result = { city: '', zipCode: '', mail: null, firstName: null, lastName: null };
    if (!isNil(orgNtwkOwner)) {
        const fullName = orgNtwkOwner.name;
        const [firstNameFromFullName, lastNameFromFullName] = isNil(fullName)
            ? [null, null]
            : fullName.split(' ');
        result = {
            firstName: orgNtwkOwner.firstName || firstNameFromFullName || '',
            lastName: orgNtwkOwner.lastName || lastNameFromFullName || '',
            mail: '',
            city: '',
            zipCode: ''
        };
    }
    return result;
};
/** To be used on both client/tech and farmer creation */
export const useArvalisSetupInfos = ({ currentOrgId }) => {
    const client = useClient();
    const org = useQuery(client.orgs.get(currentOrgId), {
        enabled: !isNil(currentOrgId)
    }).data;
    const clientId = useArvalisClientIdFromOrg(org);
    const techId = clientId?.replace(CLIENT_PREFIX, TECH_RPEFIX);
    const orgNetworkOwner = useQuery(client.orgNetworks.getMany({
        orgId: isNil(org) ? 0 : org.id
    }), {
        enabled: !isNil(org)
    }).data?.results?.[0]?.owner;
    const orgOwner = useQuery(client.members.getMany({
        orgId: isNil(org) ? 0 : org.id,
        roles: [OrgRole.owner]
    }), {
        enabled: !isNil(org)
    }).data?.results?.[0];
    const setupInfos = !isNil(orgNetworkOwner)
        ? getInfosFromOrgNetwork(orgNetworkOwner)
        : getInfosFromMember(orgOwner);
    const farmerId = `${FARMER_PREFIX}${currentOrgId}`;
    const farmer = {
        id: farmerId,
        ...getInfosFromMember(orgOwner)
    };
    return { setupInfos, org, clientId: clientId, techId: techId, farmer };
};
